export class Mat{
    ua_idbanner:string;
    ua_campus:string;
    FechaNacimiento?: string;
}